module.exports = __webpack_public_path__ + "static/media/gmail.13260813.png";